
import React from 'react'


export default function CandidateWorkingInProgress() {
   
    return (
      
        <div className='text-center text-xl p-6 h-screen'>
          <h1>Candidate</h1>
          <h2>
            {'This feature is currently under work in progress. It will be available shortly. We will notify once it is available'}
           </h2>
        </div>
    );
}
